import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../components/Navigation";

const AdminPanelScreen = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("overview");

  // Mock admin data
  const systemStats = {
    totalUsers: 1247,
    activeUsers: 892,
    totalTransactions: 15420,
    totalPortfolioValue: "$45.2M",
    systemUptime: "99.9%",
    lastBackup: "2024-01-15 02:30:00",
  };

  const recentActivities = [
    {
      id: 1,
      user: "user123",
      action: "Added investment AAPL",
      time: "2 minutes ago",
    },
    {
      id: 2,
      user: "user456",
      action: "Sold TSLA shares",
      time: "5 minutes ago",
    },
    {
      id: 3,
      user: "user789",
      action: "Updated cash available",
      time: "12 minutes ago",
    },
    {
      id: 4,
      user: "user101",
      action: "Created new account",
      time: "15 minutes ago",
    },
  ];

  const systemHealth = {
    database: "Healthy",
    api: "Healthy",
    cache: "Healthy",
    storage: "Healthy",
  };

  return (
    <div className="screen">
      <div className="screen-header">
        <h1 className="screen-title">Admin Panel</h1>
        <p className="screen-subtitle">System administration and monitoring</p>
      </div>

      {/* System Overview */}
      <div className="portfolio-summary">
        <div className="portfolio-card">
          <div className="portfolio-value">{systemStats.totalUsers}</div>
          <div className="portfolio-label">Total Users</div>
        </div>
        <div className="portfolio-card">
          <div className="portfolio-value">{systemStats.activeUsers}</div>
          <div className="portfolio-label">Active Users</div>
        </div>
        <div className="portfolio-card">
          <div className="portfolio-value">{systemStats.totalTransactions}</div>
          <div className="portfolio-label">Total Transactions</div>
        </div>
        <div className="portfolio-card">
          <div className="portfolio-value">
            {systemStats.totalPortfolioValue}
          </div>
          <div className="portfolio-label">Total Portfolio Value</div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="card">
        <div className="flex gap-2" style={{ marginBottom: "20px" }}>
          <button
            onClick={() => setActiveTab("overview")}
            className={`btn ${
              activeTab === "overview" ? "" : "btn-outline"
            } btn-small`}
          >
            📊 Overview
          </button>
          <button
            onClick={() => setActiveTab("users")}
            className={`btn ${
              activeTab === "users" ? "" : "btn-outline"
            } btn-small`}
          >
            👥 Users
          </button>
          <button
            onClick={() => setActiveTab("system")}
            className={`btn ${
              activeTab === "system" ? "" : "btn-outline"
            } btn-small`}
          >
            ⚙️ System
          </button>
          <button
            onClick={() => setActiveTab("logs")}
            className={`btn ${
              activeTab === "logs" ? "" : "btn-outline"
            } btn-small`}
          >
            📋 Logs
          </button>
        </div>

        {/* Overview Tab */}
        {activeTab === "overview" && (
          <div>
            <div className="grid-2">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">System Health</h3>
                </div>
                <div style={{ color: "#94A3B8", lineHeight: "1.6" }}>
                  <div>
                    Database:{" "}
                    <span style={{ color: "#22C55E" }}>
                      {systemHealth.database}
                    </span>
                  </div>
                  <div>
                    API:{" "}
                    <span style={{ color: "#22C55E" }}>{systemHealth.api}</span>
                  </div>
                  <div>
                    Cache:{" "}
                    <span style={{ color: "#22C55E" }}>
                      {systemHealth.cache}
                    </span>
                  </div>
                  <div>
                    Storage:{" "}
                    <span style={{ color: "#22C55E" }}>
                      {systemHealth.storage}
                    </span>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">System Info</h3>
                </div>
                <div style={{ color: "#94A3B8", lineHeight: "1.6" }}>
                  <div>Uptime: {systemStats.systemUptime}</div>
                  <div>Last Backup: {systemStats.lastBackup}</div>
                  <div>Version: 1.0.0</div>
                  <div>Environment: Production</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Users Tab */}
        {activeTab === "users" && (
          <div>
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">User Management</h3>
                <button className="btn btn-small">Add User</button>
              </div>
              <div
                style={{
                  height: "300px",
                  background: "#2A2A2A",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#94A3B8",
                }}
              >
                👥 User management interface will be displayed here
              </div>
            </div>
          </div>
        )}

        {/* System Tab */}
        {activeTab === "system" && (
          <div>
            <div className="grid-2">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Database</h3>
                </div>
                <div
                  style={{
                    height: "200px",
                    background: "#2A2A2A",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#94A3B8",
                  }}
                >
                  🗄️ Database monitoring
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">API Status</h3>
                </div>
                <div
                  style={{
                    height: "200px",
                    background: "#2A2A2A",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#94A3B8",
                  }}
                >
                  🔌 API monitoring
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Logs Tab */}
        {activeTab === "logs" && (
          <div>
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Recent Activities</h3>
                <button className="btn btn-small">View All Logs</button>
              </div>
              <div className="grid-2">
                {recentActivities.map((activity) => (
                  <div key={activity.id} className="stock-item">
                    <div className="stock-header">
                      <div>
                        <div className="stock-name">{activity.action}</div>
                        <div className="stock-symbol">
                          User: {activity.user}
                        </div>
                      </div>
                      <div className="text-right">
                        <div style={{ color: "#94A3B8", fontSize: "0.9rem" }}>
                          {activity.time}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Admin Actions */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Admin Actions</h3>
        </div>
        <div className="grid-2">
          <button className="btn btn-large">🔄 System Backup</button>
          <button className="btn btn-secondary btn-large">
            📊 Generate Report
          </button>
          <button className="btn btn-outline btn-large">
            🔧 System Settings
          </button>
          <button className="btn btn-outline btn-large">
            📧 Send Notification
          </button>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Quick Statistics</h3>
        </div>
        <div className="grid-4">
          <div className="portfolio-card">
            <div className="portfolio-value">24</div>
            <div className="portfolio-label">New Users Today</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value">156</div>
            <div className="portfolio-label">Transactions Today</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value">$2.1M</div>
            <div className="portfolio-label">Volume Today</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value">0</div>
            <div className="portfolio-label">Errors Today</div>
          </div>
        </div>
      </div>

      <Navigation />
    </div>
  );
};

export default AdminPanelScreen;
